import { match } from 'ts-pattern'
import { MunicipalityViewModel } from 'functions/app/geography/view/municipality'
import { municipalityTabs } from '../constants'
import type { MunicipalityFeatures } from '@schema/featureToggle'
import { isFeatureAvailable, isFeatureEnabled } from '@app/util/featureToggle'

export type MunicipalityLayoutTabAvailabilityContext = {
  expertsCount: number
}

export const isMunicipalityDiscussionEnabled = (
  municipality: MunicipalityViewModel,
): boolean =>
  isFeatureEnabled(municipality.featureToggles, municipalityTabs.discussion)

export const isMunicipalityLatestDiscussionsSectionAvailable = (
  municipality: MunicipalityViewModel,
): boolean =>
  municipality.crowdbuildingPartner !== false &&
  isMunicipalityDiscussionEnabled(municipality)

export const isMunicipalityLayoutTabAvailable = (
  municipality: MunicipalityViewModel,
  tab: MunicipalityFeatures,
  context: MunicipalityLayoutTabAvailabilityContext,
): boolean => {
  return match(tab)
    .with(municipalityTabs.overview, () => true)
    .with(municipalityTabs.discussion, () =>
      isMunicipalityDiscussionEnabled(municipality),
    )
    .with(municipalityTabs.initiatives, (matchedTab) =>
      isFeatureEnabled(municipality.featureToggles, matchedTab),
    )
    .with(municipalityTabs.locations, (matchedTab) =>
      isFeatureEnabled(municipality.featureToggles, matchedTab),
    )
    .with(municipalityTabs.current, (matchedTab) =>
      isFeatureAvailable(municipality.featureToggles, matchedTab, [
        municipality.stories,
        municipality.news,
        municipality.blogs,
      ]),
    )
    .with(municipalityTabs.stepByStep, (matchedTab) =>
      isFeatureAvailable(municipality.featureToggles, matchedTab, [
        municipality.stepByStepPdf,
      ]),
    )
    .with(
      municipalityTabs.experts,
      (matchedTab) =>
        isFeatureEnabled(municipality.featureToggles, matchedTab) &&
        context.expertsCount > 0,
    )
    .with(municipalityTabs.knowledgeHub, (matchedTab) =>
      isFeatureAvailable(municipality.featureToggles, matchedTab, [
        municipality.knowledgeHubModules,
      ]),
    )
    .otherwise(() => false)
}
